export const EVENTS_FILTERS_DATA = "EVENTS_FILTERS_DATA";
export const EVENTS_FILTERS_LOADED = "EVENTS_FILTERS_LOADED";
export const EVENTS_FILTERS_ERROR = "EVENTS_FILTERS_ERROR";
export const EVENTS_FILTERS_APPLIED = "EVENTS_FILTERS_APPLIED";

const defaultState = {
	data: null,
	loaded: false,
	error: null,
	applied: {}
};

export default function eventsFiltersReducer(state = defaultState, action) {
	switch (action.type) {
		case EVENTS_FILTERS_DATA:
			return { ...state, data: action.payload };
		case EVENTS_FILTERS_LOADED:
			return { ...state, loaded: action.payload };
		case EVENTS_FILTERS_ERROR:
			return { ...state, error: action.payload };
		case EVENTS_FILTERS_APPLIED:
			return { ...state, applied: { ...state.applied, ...action.payload } };
		default:
			return state;
	}
}